/* HeroCard.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDyzSk%7Bborder-radius%3Avar(--ds-radius-xlarge%2C9pt)%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._23rrnHJD2S%7Btransition%3Abox-shadow%20.2s%20ease-in-out%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._3iDTPbgBM8%7Bdisplay%3Agrid%7D%0A._2iEGP2pPc1%7Bgrid-template-columns%3A43%25%201fr%7D%0A._42d1HA8HPE%7Brow-gap%3Avar(--ds-space-150%2C9pt)%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._4ouGXIdnbC%7Bmin-width%3A0%7D%0A._4kiQYAPIoL%7Bmin-height%3A220px%7D%0A._0jFU0VN91d%7Bheight%3A100%25%7D%0A._46hvQmNHnM%7Bpadding-block-start%3Avar(--ds-space-300%2C24px)%7D%0A._0xmtkoNHnM%7Bpadding-block-end%3Avar(--ds-space-300%2C24px)%7D%0A._0LQT5ENHnM%7Bpadding-inline-start%3Avar(--ds-space-300%2C24px)%7D%0A._03SyCPNHnM%7Bpadding-inline-end%3Avar(--ds-space-300%2C24px)%7D%0A._0KLXrunmFW%7Bbackground-color%3Avar(--ds-surface-sunken%2C%23f8f8f8)%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._1SdfoHYbGa%7Btransition%3Anone%7D%7D%0A._2j3gqA7dHp%7Bgrid-column%3A1%7D%0A._4xdlr07p2s%7Balign-self%3Astart%7D%0A._46hvQmkG2W%7Bpadding-block-start%3Avar(--ds-space-250%2C20px)%7D%0A._3zvHkHdC7N%7Boverflow-wrap%3Aanywhere%7D%0A._0ca6V7MUDv%7Bgrid-template-rows%3A1fr%20auto%7D%0A._3B2K2QiZR3%7Bgrid-row%3A2%7D%0A._2p6ht97p2s%7Bjustify-self%3Astart%7D%0A._42Yu6B7dHp%7Bz-index%3A1%7D%0A._23rrnHaO0L%7Btransition%3Atransform%20.2s%20ease-in-out%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._2I62gzNHnM%7Binset-block-start%3Avar(--ds-space-300%2C24px)%7D%0A._1OKFqYNHnM%7Binset-inline-end%3Avar(--ds-space-300%2C24px)%7D%0A._39xV02nQIZ%7Bwidth%3A46%25%7D%0A._1EqgXlsz7G%7Bmax-width%3A20pc%7D%0A._0jFU0VwBC3%7Bheight%3A360px%7D%0A._1pp6NdYbGa%7Bpointer-events%3Anone%7D%0A._1VJPcaunCX%7Btransform%3Arotate(0deg)%7D%0A._3AFhRbdYBJ%3Ahover%3E%5Bdata-hero-card-preview%5D%7Btransform%3Arotate(-3deg)%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._0TqsNNYbGa%3Ahover%3E%5Bdata-hero-card-preview%5D%7Btransform%3Anone%7D%7D%0A._3fSdSTGk8v%3Ahover%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D%0A._2I62gzPgdg%7Binset-block-start%3Avar(--ds-space-0%2C0)%7D%0A._1ZB6UyPgdg%7Binset-block-end%3Avar(--ds-space-0%2C0)%7D%0A._3iC0zdPgdg%7Binset-inline-start%3Avar(--ds-space-0%2C0)%7D%0A._1OKFqYPgdg%7Binset-inline-end%3Avar(--ds-space-0%2C0)%7D%0A._0KLXrujOvk%7Bbackground-color%3Atransparent%7D%0A._34b3D25UaJ%3Afocus-visible%7Boutline-offset%3Avar(--ds-space-negative-050%2C-4px)%7D%0A._0wOv4Q18ZR%7Bcursor%3Adefault%7D");













































import React from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { StudioBrowseKitIntlProvider } from '../../../i18n/StudioBrowseKitIntlProvider';
import type { CardProps } from '../../types';
const styles = {
  root: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _23rrnHJD2S _1mT5xdRAKS _3iDTPbgBM8 _2iEGP2pPc1 _42d1HA8HPE _0hPCNLDIqT _24h04i2Njc _4ouGXIdnbC _4kiQYAPIoL _0jFU0VN91d _46hvQmNHnM _0xmtkoNHnM _0LQT5ENHnM _03SyCPNHnM _0KLXrunmFW _1SdfoHYbGa",
  summary: "_2j3gqA7dHp _4xdlr07p2s _46hvQmkG2W _4ouGXIdnbC _3zvHkHdC7N",
  withActions: "_0ca6V7MUDv",
  actions: "_2j3gqA7dHp _3B2K2QiZR3 _2p6ht97p2s _1mT5xdRAKS _42Yu6B7dHp",
  preview: "_0bjKvDyzSk _23rrnHaO0L _1mT5xdWVPG _2I62gzNHnM _1OKFqYNHnM _39xV02nQIZ _1EqgXlsz7G _0jFU0VwBC3 _1pp6NdYbGa _1VJPcaunCX _1SdfoHYbGa",
  interactive: "_3AFhRbdYBJ _0TqsNNYbGa _3fSdSTGk8v",
  pressable: "_0bjKvDyzSk _1mT5xdWVPG _2I62gzPgdg _1ZB6UyPgdg _3iC0zdPgdg _1OKFqYPgdg _42Yu6B7dHp _0KLXrujOvk _34b3D25UaJ",
  disabledPressable: "_0wOv4Q18ZR"
};
export type HeroCardProps = Pick<CardProps, 'isDisabled' | 'testId' | 'xcss'> & {
  name?: string;
  onClick?: () => void;
  summary: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
};
export const HeroCard = ({
  name,
  onClick,
  isDisabled,
  testId,
  xcss,
  summary,
  actions,
  children
}: HeroCardProps): React.JSX.Element => <StudioBrowseKitIntlProvider>
		<Box xcss={cx(styles.root, Boolean(actions) && styles.withActions, Boolean(onClick) && !isDisabled && styles.interactive, xcss)} testId={testId}>
			<Box xcss={styles.summary}>{summary}</Box>
			<Box xcss={styles.preview} data-hero-card-preview aria-hidden="true">
				{children}
			</Box>
			{onClick ? <Pressable xcss={cx(styles.pressable, isDisabled && styles.disabledPressable)} aria-label={name} onClick={onClick} isDisabled={isDisabled} testId={testId ? `${testId}--action` : undefined} /> : null}
			{actions ? <Box xcss={styles.actions} data-hero-card-actions>
					{actions}
				</Box> : null}
		</Box>
	</StudioBrowseKitIntlProvider>;